import mn_whatsapp_campaign from "../../../../../images/LandingPageImage/mn_whatsapp_campaign.webp";
import mn_audience_tracking from "../../../../../images/LandingPageImage/mn_audience_tracking.webp";
import mn_template_creation from "../../../../../images/LandingPageImage/mn_template_creation.webp";
import auto_reply_smart_flow from "../../../../../images/LandingPageImage/auto_reply_smart_flow.webp";
import google from "../../../../../images/LandingPageImage/google.png";
import "../../styles/LandingPageCss/MainHomeSection.css";
import { FaArrowRightLong } from "react-icons/fa6";

import { useModal } from "../../../../../MyContext";
import { Link } from "react-router-dom";

export default function AdvancedFeatures() {
  const { openModal } = useModal();
  return (
    <>
      <section className="bg-light py-5 py-md-6 font-sans px-3 px-md-4">
        <header className="text-center container mb-4 mb-md-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="new-section-title mb-3 mb-md-4">Features</h2>
              <p className="new-section-subtitle mt-3">
                Lead Your Market Effortlessly with Our Innovative WhatsApp
                Business Solution
              </p>
            </div>
          </div>
        </header>

        <div className="container mb-5 mb-md-6">
          <div className="bg-ryleigh position-relative overflow-hidden feature-shape">
            <div className="row align-items-center g-0">
              <div className="col-12 col-md-6 order-1 order-md-1">
                <div className="p-4 py-md-7 text-center">
                  <img
                    src={mn_whatsapp_campaign}
                    alt="WhatsApp Campaigns"
                    className="img-fluid"
                    style={{ maxHeight: "400px", objectFit: "cover" }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 order-2 order-md-1">
                <div className="p-4 p-md-5 py-md-7 ">
                  <h3 className="font-monospace  display-7 fw-semibold mb-3 mb-md-3">
                    WhatsApp Campaigns
                  </h3>
                  <p className="fs-9 mb-2">
                    Message Notifier makes WhatsApp campaigns simple and
                    impactful by allowing businesses to broadcast messages to
                    the right audience at the right time. From product launches
                    to important announcements, campaigns can be scheduled,
                    automated, and personalized with ease. Businesses can engage
                    customers directly on WhatsApp while maintaining consistency
                    and message control. With smart campaign tools, outreach
                    becomes faster, more reliable, and results-driven.
                  </p>

                  <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                    <Link
                      to="/whatsApp_campaign"
                      className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                    >
                      <span className="text-nowrap fs-6">Read More</span>
                      <FaArrowRightLong size={18} />
                    </Link>

                    <button
                      onClick={openModal}
                      className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                    >
                      <span className="text-nowrap fs-5">Book a Demo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5 mb-md-6">
          <div className="bg-lavender  position-relative overflow-hidden feature-shape">
            <div className="row align-items-center g-0">
              <div className="col-12 col-md-6 order-1 order-md-1">
                <div className="p-4 py-md-7 text-center">
                  <img
                    src={mn_audience_tracking}
                    alt="WhatsApp Campaigns"
                    className="img-fluid"
                    style={{ maxHeight: "400px", objectFit: "cover" }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 order-2 order-md-1">
                <div className="p-4 p-md-5 py-md-7 ">
                  <h3 className="font-monospace  display-7 fw-semibold mb-3 mb-md-3">
                    Audience Targeting
                  </h3>
                  <p className="fs-9 mb-2">
                    Message Notifier lets businesses refine their audience
                    targeting so messages reach the right customers with
                    precision. By segmenting contacts based on behavior,
                    preferences, or engagement history, you can send more
                    relevant updates and offers. This helps increase response
                    rates and builds stronger customer relationships through
                    personalized communication. With targeted messaging, your
                    campaigns become more efficient, meaningful, and impactful.
                  </p>

                  <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                    <Link
                      to="/audience_targeting"
                      className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                    >
                      <span className="text-nowrap fs-6">Read More</span>
                      <FaArrowRightLong size={18} />
                    </Link>
                    <button
                      onClick={openModal}
                      className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                    >
                      <span className="text-nowrap fs-5">Book a Demo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5 mb-md-6">
          <div className="bg-mustard position-relative overflow-hidden feature-shape">
            <div className="row align-items-center g-0">
              <div className="col-12 col-md-6 order-1 order-md-1">
                <div className="p-4 py-md-7 text-center">
                  <img
                    src={mn_template_creation}
                    alt="WhatsApp Campaigns"
                    className="img-fluid"
                    style={{ maxHeight: "400px", objectFit: "cover" }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 order-2 order-md-1">
                <div className="p-4 p-md-5 py-md-7 ">
                  <h3 className="font-monospace  display-7 fw-semibold mb-3 mb-md-3">
                    Personalized Mesages
                  </h3>
                  <p className="fs-9 mb-2">
                    Message Notifier enables businesses to send personalized
                    messages that speak directly to each customer’s needs and
                    preferences. By customizing greetings, offers, and updates,
                    you can create stronger connections and make every
                    interaction feel more meaningful. Personalized messaging
                    enhances engagement, boosts customer satisfaction, and
                    increases the likelihood of conversions. With smart
                    automation tools, tailoring messages at scale becomes simple
                    and effective.
                  </p>

                  <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                    <Link
                      to="/personalized_messages"
                      className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                    >
                      <span className="text-nowrap fs-6">Read More</span>
                      <FaArrowRightLong size={18} />
                    </Link>
                    <button
                      onClick={openModal}
                      className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                    >
                      <span className="text-nowrap fs-5">Book a Demo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="bg-pale  position-relative overflow-hidden feature-shape">
            <div className="row align-items-center g-0">
              <div className="col-12 col-md-6 order-1 order-md-1">
                <div className="p-4 py-md-7 text-center">
                  <img
                    src={auto_reply_smart_flow}
                    alt="WhatsApp Campaigns"
                    className="img-fluid"
                    style={{ maxHeight: "400px", objectFit: "cover" }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 order-2 order-md-1">
                <div className="p-4 p-md-5 py-md-7 ">
                  <h3 className="font-monospace  display-7 fw-semibold mb-3 mb-md-3">
                    Automated Replies & Smart Flows
                  </h3>
                  <p className="fs-9 mb-2">
                    Message Notifier’s automated replies and smart flows help
                    businesses respond instantly to customer messages without
                    manual effort. With custom logic and predefined rules, you
                    can set intelligent paths that guide conversations and
                    answer questions automatically. This ensures timely
                    engagement, reduces response delays, and enhances customer
                    satisfaction. By automating routine interactions, your team
                    can focus on more important tasks while communication stays
                    smooth and reliable.
                  </p>

                  <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                    <Link
                      to="/automated_replies"
                      className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                    >
                      <span className="text-nowrap fs-6">Read More</span>
                      <FaArrowRightLong size={18} />
                    </Link>
                    <button
                      onClick={openModal}
                      className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                    >
                      <span className="text-nowrap fs-5">Book a Demo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
